<template>
  <div id="diy_table">
    <!-- 自定义表格组件 -->
    <div class="search" v-if="searchData.length > 0 || buttonList.length > 0">
      <div class="line" v-for="(item, index) in searchData" :key="index">
        <div class="title" v-if="item.title != ''">{{ item.title }}:</div>
        <div class="value" v-if="item.type == 'input'">
          <!-- 输入框 -->
          <el-input
            v-model="item.value"
            :placeholder="'请输入' + item.title"
            clearable
            @keyup.enter.native="initTable"
          ></el-input>
        </div>
        <div class="value" v-if="item.type == 'select'">
          <!-- 选择器 -->
          <el-select
            v-model="item.value"
            :placeholder="'请选择' + item.title"
            clearable
            filterable
            @change="initTable"
          >
            <el-option
              v-for="it in item.options"
              :key="it.value"
              :label="it.label"
              :value="it.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="value" v-if="item.type == 'selects'">
          <!-- 选择器--多选 -->
          <el-select
            v-model="item.value"
            :placeholder="'请选择' + item.title"
            clearable
            filterable
            multiple
            @change="initTable"
          >
            <el-option
              v-for="it in item.options"
              :key="it.value"
              :label="it.label"
              :value="it.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="value" v-if="item.type == 'select-obj'">
          <!-- 选择器--选择对象 -->
          <el-select
            v-model="item.value"
            :placeholder="'请选择' + item.title"
            clearable
            filterable
            value-key="value"
            @change="initTable"
          >
            <el-option
              v-for="it in item.options"
              :key="it.value"
              :label="it.label"
              :value="it"
            >
            </el-option>
          </el-select>
        </div>
        <div class="value" v-if="item.type == 'time'">
          <!-- 时间选择器-- 只到月份 -->
          <el-date-picker
            v-model="item.value"
            type="month"
            placeholder="选择时间"
            value-format="yyyy-MM"
            @change="initTable"
          >
          </el-date-picker>
        </div>
        <div class="value" v-if="item.type == 'time-range'">
          <!-- 时间选择器-- 只到月份 -- 范围 -->
          <el-date-picker
            v-model="item.value"
            type="monthrange"
            placeholder="选择时间"
            value-format="yyyy-MM"
            @change="initTable"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          >
          </el-date-picker>
        </div>
        <div class="value" v-if="item.type == 'time-year'">
          <!-- 时间选择器-- 只到年份 -->
          <el-date-picker
            v-model="item.value"
            type="year"
            :placeholder="'选择' + item.title"
            value-format="yyyy"
            @change="initTable"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="perch-active"></div>
      <div class="buts">
        <div
          class="add_but"
          v-for="(item, index) in buttonList"
          :key="index"
          @click="handleClickTop(item.active)"
        >
          <i :class="item.icon" v-if="item.icon"></i>
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tips" v-if="tipData.length > 0">
        <div
          :class="{ tip: true, 'active-tip': isActive == tip.key }"
          v-for="(tip, index) in tipData"
          :key="index"
          @click="selectTip(tip)"
        >
          {{ tip.text }}
        </div>
      </div>
      <div class="table">
        <el-table
          v-loading="loading"
          ref="singleTable"
          :data="tableData"
          highlight-current-row
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
        >
          <el-table-column width="55" type="index"> </el-table-column>
          <el-table-column width="55" type="selection" v-if="isSelect">
          </el-table-column>
          <template
            ><el-table-column
              v-for="(item, index) in tableMenu"
              :property="item.key"
              :key="index"
              :label="item.name"
              show-overflow-tooltip
              style="background-color: #eee"
              :width="item.width"
              :sortable="item.sort"
            >
              <template slot-scope="scope">
                <div class="star" v-if="item.key == 'gradeOfDifficulty'">
                  <!-- 难度显示星星 -->
                  <div v-if="item.isStar">
                    <i
                      :class="{
                        'el-icon-star-off': true,
                        'el-icon-star-on': scope.row[item.key] >= s,
                      }"
                      v-for="s in 5"
                      :key="s"
                    ></i>
                  </div>
                </div>
                <div
                  v-else
                  :style="{ color: item.isPrimary ? '#EA5412' : '#333' }"
                >
                  <span v-if="item.isHtml" v-html="scope.row[item.key]"></span>
                  <span
                    v-else-if="item.isColor"
                    :style="{ color: scope.row.rowColor }"
                    >{{ scope.row[item.key] }}
                    <span
                      v-if="
                        item.hasTip &&
                        scope.row.hasTip &&
                        scope.row.hasTip != ''
                      "
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.hasTip"
                        placement="top-start"
                      >
                        <i class="el-icon-warning"></i>
                      </el-tooltip> </span
                  ></span>
                  <span v-else> {{ scope.row[item.key] }}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="tableState">
            <!-- 带状态的=表格按钮 -->
            <el-table-column fixed="right" label="操作" width="260">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row, but.active)"
                  type="text"
                  size="small"
                  v-for="(but, index) in scope.row.butList"
                  :key="index"
                  >{{ but.text }}</el-button
                >
              </template>
            </el-table-column>
          </template>
          <template v-else-if="tableButton.length > 0">
            <!-- 普通表格按钮 -->
            <el-table-column fixed="right" label="操作" width="220">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row, but.active)"
                  type="text"
                  size="small"
                  v-for="(but, index) in tableButton"
                  :key="index"
                  >{{ but.text }}</el-button
                >
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="page" v-if="pageData.currentPage">
        <el-pagination
          @current-change="initTable"
          :current-page.sync="pageData.currentPage"
          :page-size="pageData.pageSize"
          layout="total, prev, pager, next,jumper"
          :total="pageData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_table",
  props: {
    searchData: {
      // 搜索框
      type: Array,
      default: function () {
        return [];
      },
    },
    buttonList: {
      // 按钮组
      type: Array,
      default: function () {
        return [];
      },
    },
    tipData: {
      // 标签
      type: Array,
      default: function () {
        return [];
      },
    },
    active: {
      type: String,
      default: "all",
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    tableMenu: {
      // 表头
      type: Array,
      default: function () {
        return [{}];
      },
    },
    tableData: {
      // 表格数据
      type: Array,
      default: function () {
        return [];
      },
    },
    tableButton: {
      // 表格中的操作按钮
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pageData: {
      // 表格中的操作按钮
      type: Object,
      default: function () {
        return {};
      },
    },
    tableState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.active,
    };
  },
  watch: {
    active() {
      this.isActive = this.active;
    },
    isActive(newValue) {
      this.$emit("showActive", this.isActive);
    },
  },
  methods: {
    handleClickTop(active) {
      this.$emit("handleClickTop", active);
    },
    /**
     * 切换标签
     */
    selectTip(tip) {
      this.isActive = tip.key;
      this.initTable();
    },
    /**
     * 获取表格数据
     */
    initTable() {
      this.$emit("initTable", {
        searchData: this.searchData,
        pageData: this.pageData,
      });
    },
    /**
     * 表格中的操作
     */
    handleClick(item, active) {
      this.$emit("handleClick", { item, active });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    /**
     * 排序事件
     */
    handleSortChange(val) {
      let data = {
        prop: val.prop,
        order: val.order,
      };
      this.$emit("handleSortChange", data);
    },
  },
};
</script>

<style lang="less" scoped>
#diy_table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  box-sizing: border-box;
  > .search {
    width: 100%;
    height: auto;
    min-height: 60px;
    background-color: #fff;
    // color: #22c02f;
    display: flex;
    flex-wrap: wrap;
    > .line {
      min-width: 280px;
      width: auto;
      height: 40px;
      display: flex;
      margin-top: 10px;
      margin-left: 10px;
      > .title {
        width: auto;
        height: 40px;
        font-size: 13px;
        line-height: 45px;
        text-align: center;
        margin-right: 8px;
      }
    }
    > .buts {
      width: auto;
      display: flex;
    }
    // color: #82e06a;
  }
  > .content {
    width: 100%;
    height: 0;
    flex: 1;
    margin-top: 10px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    > .tips {
      width: 100%;
      height: 45px;
      border-bottom: @cut-off-rule;
      display: flex;
      box-sizing: border-box;
      > .tip {
        width: auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 30px;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        transition: 0.3s;
        border-bottom: 1px solid #33333300;
        &:hover {
          color: @baseColor;
        }
      }
      > .active-tip {
        color: @baseColor;
        border-bottom: 1px solid @baseColor;
      }
    }
    > .table {
      width: 100%;
      height: 0;
      flex: 1;
      .el-icon-star-off {
        font-size: 15px;
        color: #e9e9e9;
      }
      .el-icon-star-on {
        color: #ffe710;
        font-size: 17px;
      }
    }
    > .page {
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 20px;
      border-top: @cut-off-rule;
      box-sizing: border-box;
    }
  }
}
</style>